import React from 'react';

interface PermissionLoaderProps {
  isLoading: boolean;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const PermissionLoader: React.FC<PermissionLoaderProps> = ({ 
  isLoading, 
  children, 
  fallback = <div className="animate-pulse bg-gray-200 h-4 w-20 rounded"></div> 
}) => {
  if (isLoading) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}; 